/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { FairPlayKeySystem, PlayerSource } from "./types";

export const isFairPlaySource = (
  source: PlayerSource,
): source is PlayerSource & {
  keySystems: {
    "com.apple.fps.1_0": FairPlayKeySystem;
  };
} => {
  return (
    source.keySystems !== undefined &&
    "com.apple.fps.1_0" in source.keySystems &&
    source.keySystems["com.apple.fps.1_0"] !== undefined
  );
};

export const isWidevineSource = (
  source: PlayerSource,
): source is PlayerSource & {
  keySystems: {
    "com.widevine.alpha": string;
  };
} => {
  return (
    source.keySystems !== undefined && "com.widevine.alpha" in source.keySystems
  );
};

export const isPlayReadySource = (
  source: PlayerSource,
): source is PlayerSource & {
  keySystems: {
    "com.microsoft.playready": string;
  };
} => {
  return (
    source.keySystems !== undefined &&
    "com.microsoft.playready" in source.keySystems
  );
};
